import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { IMarketTemplate } from '@frontend/oxygen/core-utils';
import { IMarket, IOutcome, ISportEvent } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { CmsService } from '../../../core/services/cms/cms.service';
import { ISystemConfig } from '../../../core/services/cms/models';
import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { DeviceService } from '../../../core/services/device/device.service';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { GtmTrackingService } from '../../../core/services/gtmTracking/gtm-tracking.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { IGroupedMarket, IGroupedMarketHeader, INoGoalScorer } from '../../services/marketsGroup/markets-group.model';

@Component({
    selector: 'markets-group-component',
    templateUrl: 'markets-group.component.html',
    standalone: false,
})
export class MarketsGroupComponent implements OnInit, OnDestroy {
    @Input() marketsGroup: IGroupedMarket;
    @Input() markets: IMarket[];
    @Input() isExpanded: boolean;
    @Input() memoryId: string;
    @Input() memoryLocation: string;
    @Input() eventEntity: ISportEvent;
    @Input() bybTabAvb: boolean;
    @Input() isEDPPage: boolean;
    @Input() activeTabp: string = '';

    switchers: any[] = [];
    marketNoGoal: INoGoalScorer;
    isMarketHeader: boolean;
    isMarketRow: boolean;
    isMarketCard: boolean;
    isAllShow: boolean = false;
    periodIndex: number = 0;
    limitCount: number = 0;
    marketNames: string[] = [''];
    isMarketwithPB: boolean;
    isPlayerCaredMarket: boolean;
    isDesktop: boolean;
    reloadPB: boolean = true;
    @Input() isOptaAvailable: boolean;
    @Input() isFootball: boolean;
    @Input() isOptaProviderPresent: boolean;
    protected readonly PLAYER_BETS_LOADED = 'PLAYER_BETS_LOADED';

    private isMarketTeams: boolean;
    private marketCount: number;

    constructor(
        protected pubSubService: PubSubService,
        protected changeDetectorRef: ChangeDetectorRef,
        protected cmsService: CmsService,
        protected windowRefService: WindowRefService,
        protected deviceService: DeviceService,
        public gtmService: GtmService,
        public gtmTrackingService: GtmTrackingService,
    ) {}

    ngOnInit(): void {
        this.isMarketHeader = this.marketsGroup.header && this.marketsGroup.template === 'cardHeader';
        this.isPlayerCaredMarket = this.marketsGroup.localeName === 'ToGetCarded';
        this.isMarketwithPB = !!(this.marketsGroup.isPlayerBets && this.isMarketHeader && !this.isPlayerCaredMarket);
        this.isDesktop = this.deviceService.isDesktop;
        this.marketNoGoal = this.marketsGroup.noGoalscorer as INoGoalScorer;
        if (this.marketNoGoal) {
            this.marketNoGoal.marketInfo = {};
            //To-Do : Need to check duplicate market issue
            /*
            {    
                bwinId: this.marketsGroup.bwinId,
                bybAvailableMarket: this.marketsGroup.bybAvailableMarket,
                drilldownTagNames: this.marketsGroup.drilldownTagNames,
            };
             */
        }
        this.isMarketCard = this.marketsGroup.template === 'card';
        this.isMarketRow = this.marketsGroup.template === 'row';
        this.isMarketTeams = !!(
            this.marketsGroup.type &&
            (this.marketsGroup.type.indexOf('teams') !== -1 || this.marketsGroup.type.indexOf('teamSwitch') !== -1)
        );
        this.marketCount = this.marketNoGoal ? this.marketsGroup.lessCount - 1 : this.marketsGroup.lessCount;

        this.pubSubService.subscribe('MarketsGroupComponent', this.pubSubService.API.OUTCOME_UPDATED, (market: IMarket) => {
            if (market.outcomes) {
                _.each(market.outcomes, (outcome: IOutcome) => (outcome.marketStatusCode = market.marketStatusCode));
            }
        });

        if (this.marketsGroup.periods) {
            this.marketsGroup.periods.forEach((market) => {
                if (market.localeName) {
                    const switchers = {
                        name: this.isMarketTeams ? market.localeName : `sb.${market.localeName}`,
                        onClick: (index: number) => this.selectPeriod(index),
                    };
                    this.switchers.push(switchers);
                    if (
                        this.marketsGroup.localeName === 'playerToScoreFirst' &&
                        market.markets?.length &&
                        market.markets[0]?.outcomeMeaningMinorCode?.length &&
                        market.markets[0]?.outcomeMeaningMinorCode?.[0]?.toString() === '3'
                    ) {
                        market.markets.forEach((player) => {
                            if (player.outcomes?.length === 3) {
                                player.outcomes.reverse();
                                [player.outcomes[0].sortOrder, player.outcomes[2].sortOrder] = [
                                    player.outcomes[2].sortOrder,
                                    player.outcomes[0].sortOrder,
                                ];
                            }
                        });
                    }
                }
            });
        }
        this.cmsService.getSystemConfig().subscribe((config: ISystemConfig) => {
            if (config && config.FootballAggregationMarkets) {
                this.marketNames = config.FootballAggregationMarkets.marketNames;
            }
        });
        this.marketsGroup.isLoaded = this.isMarketwithPB && this.isDesktop && this.marketsLength() ? false : true;
    }
    /**
     * update isLoaded value
     * @param isLoaded
     */
    playerbetsLoaded(isLoaded: boolean) {
        this.marketsGroup.isLoaded = isLoaded;
        this.changeDetectorRef.detectChanges();
    }
    changeAccordionState(state: boolean, market: IMarket | IMarketTemplate): void {
        this.isExpanded = state;
        if (!state) {
            this.marketsGroup.isLoaded = !(this.isDesktop && this.isMarketwithPB);
        }
        this.gtmPush('market accordion', state ? 'expand' : 'collapse', this.activeTabp, market?.name);
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.pubSubService.unsubscribe('MarketsGroupComponent');
        this.isDesktop && this.pubSubService.unsubscribe(`marketGroup-${this.marketsGroup.localeName}`);
    }

    /**
     * Show/Hide Less Button
     *
     * @returns {boolean}
     */
    get showLessButton(): boolean {
        return this.marketsLength() > this.marketCount && this.marketCount > 0;
    }
    set showLessButton(value: boolean) {}
    /**
     * get Outcomes of Market in correct order
     * @param market
     * @param index
     */
    getMarketOutcomes(market: IMarket, index: number): IOutcome[] {
        return this.removeUnusedFakes(market.outcomes);
    }

    /**
     * Hide market header if markets length <= 2
     */
    showHeader(): boolean {
        if (this.marketsGroup.localeName == 'playerToScoreResult' && this.marketsGroup.header?.length <= 1) {
            return true;
        } else {
            return this.marketNames?.includes(this.marketsGroup.name) && this.marketsGroup.header?.length <= 2;
        }
    }

    trackById(index: number, outcome: IOutcome): number {
        return Number(outcome.id);
    }

    /***
     * Get Selected Market
     *
     * @param {number} periodIndex
     * @returns {IMarket[]}
     */
    selectedMarkets(periodIndex: number): IMarket[] {
        const marketData: IMarket[] = (
            this.marketsGroup.periods ? this.marketsGroup.periods[periodIndex].markets : this.marketsGroup.markets
        ) as IMarket[];
        marketData.sort((a: IMarket, b: IMarket) => {
            const orderA = a?.outcomes?.[0]?.displayOrder ?? Infinity;
            const orderB = b?.outcomes?.[0]?.displayOrder ?? Infinity;
            return orderA - orderB;
        });
        const hasMarketCount = this.marketCount && this.isMarketHeader;
        return hasMarketCount ? marketData.slice(0, this.limitCount || this.marketCount) : marketData;
    }

    /***
     * Get Selected Outcomes
     *
     * @param {IOutcome[]} outcomes
     * @returns {IOutcome[]}
     */
    selectedOutcomes(outcomes: IOutcome[]): IOutcome[] {
        outcomes.sort((a: any, b: any) => {
            const isANoGoalscorer = a.name === 'No Goalscorer';
            const isBNoGoalscorer = b.name === 'No Goalscorer';
            return isANoGoalscorer ? (isBNoGoalscorer ? 0 : 1) : isBNoGoalscorer ? -1 : a.displayOrder - b.displayOrder;
        });
        return this.marketCount ? outcomes.slice(0, this.limitCount || this.marketCount) : outcomes;
    }

    /**
     * Get Markets Length
     */
    marketsLength(): number {
        const selectedMarket = this.marketsGroup.periods ? this.marketsGroup.periods[this.periodIndex].markets : this.marketsGroup.markets;
        if (this.isMarketHeader) {
            return this.marketNoGoal ? selectedMarket.length + 1 : selectedMarket.length;
        }
        return selectedMarket[0] && selectedMarket[0].outcomes && selectedMarket[0].outcomes.length;
    }

    /**
     * Toggle Button for Show All
     */
    toggleShow(): void {
        this.isAllShow = !this.isAllShow;
        this.limitCount = this.isAllShow ? this.marketsLength() : this.marketCount;
        this.changeDetectorRef.detectChanges();
    }

    /**
     * Track by function
     * @param {number} index
     * @returns {string}
     */
    trackByFn(index: number): number {
        return index;
    }

    /**
     * select Period by array index
     * @param periodIndex
     */
    private selectPeriod(periodIndex: number): void {
        const isMarketsAvailable = this.marketsLength();
        this.reloadPB = !!isMarketsAvailable;
        this.changeDetectorRef.detectChanges();
        this.periodIndex = periodIndex;
        if (this.marketCount) {
            this.isAllShow = false;
            this.limitCount = this.marketCount;
        }
        const oddsTablesforplayerBets = this.windowRefService.document.querySelector('#' + this.marketsGroup.localeName);
        if (oddsTablesforplayerBets) {
            oddsTablesforplayerBets.scrollLeft = 0;
        }
        if (!isMarketsAvailable) {
            this.reloadPB = true;
            this.changeDetectorRef.detectChanges();
        }
        this.isDesktop &&
            oddsTablesforplayerBets &&
            this.pubSubService.publish(this.PLAYER_BETS_LOADED, { localeName: this.marketsGroup.localeName, periodIndex });
    }

    protected removeUnusedFakes(outcomes: IOutcome[]): IOutcome[] {
        const headers = this.marketsGroup.header;

        return outcomes.filter((outcomeItem: IOutcome) => headers.some((header: IGroupedMarketHeader) => header.sortOrder === outcomeItem.sortOrder));
    }

    gtmPush(categoryEvent: string, actionEvent: string, positionEvent: string, name?: string): void {
        this.gtmTrackingService.location = this.gtmTrackingService.location?.toLowerCase();
        this.gtmService.push('Event.Tracking', {
            'component.CategoryEvent': categoryEvent,
            'component.LabelEvent': this.eventEntity?.isLiveNowEvent ? 'in-play' : 'pre-match',
            'component.ActionEvent': actionEvent,
            'component.PositionEvent': positionEvent,
            'component.LocationEvent': 'edp',
            'component.EventDetails': name,
            'component.URLClicked': 'not applicable',
            'component.ContentPosition': 'not applicable',
            'eventID': Number(this.eventEntity?.id || 0),
            'categoryID': Number(this.eventEntity?.categoryId || 0),
            'typeID': this.eventEntity?.typeId || 0,
        });
    }
}
